import React, { useState, useEffect, createContext } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, CardContent, Divider, MenuItem, Grid, InputLabel, TextField, Button } from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import MaterialTable from "material-table";
import { useAlert } from "react-alert";
import { Formik } from 'formik';
import * as Yup from "yup";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

const screenCode = 'ITEMCATEGORYCREATION';
export default function ItemCategoryListing() {
  const classes = useStyles();
  const alert = useAlert();
  const [factoryItemData, setFactoryItemData] = useState([]);
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [IDDataForDefaultLoad, setIsIDDataForDefaultLoad] = useState(null);
  const [itemCategoryList, setItemCategoryList] = useState({
    groupID: 0,
    factoryID: 0
  })
  const [page, setPage] = useState(0);

  const navigate = useNavigate();
  let encrypted = "";
  const handleClick = () => {
    encrypted = btoa('0');
    navigate('/app/itemCategory/addedit/' + encrypted);
  }

  const handleClickEdit = (itemCategoryID) => {
    encrypted = btoa(itemCategoryID.toString());
    let modelID = {
      groupID: parseInt(itemCategoryList.groupID),
      factoryID: parseInt(itemCategoryList.factoryID),
      page: page
    };
    sessionStorage.setItem(
      'itemCategory-listing-page-search-parameters-id',
      JSON.stringify(modelID)
    );
    navigate('/app/itemCategory/addedit/' + encrypted);
  }

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });

  useEffect(() => {
    const IDdata = JSON.parse(
      sessionStorage.getItem('itemCategory-listing-page-search-parameters-id')
    );
    getPermissions(IDdata);
  }, []);

  useEffect(() => {
    sessionStorage.removeItem(
      'itemCategory-listing-page-search-parameters-id'
    );
  }, []);

  useEffect(() => {
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropdown());
  }, [itemCategoryList.groupID]);

  useEffect(() => {
    if (IDDataForDefaultLoad != null) {
      GetItemCategoryDetailsByGroupIDFactoryID();
    }
  }, [IDDataForDefaultLoad]);

  useEffect(() => {
    setFactoryItemData([]);
  }, [itemCategoryList.groupID, itemCategoryList.factoryID]);

  async function getPermissions(IDdata) {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWITEMCATEGORY');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    const isInitialLoad = IDdata === null
    if (isInitialLoad) {
      setItemCategoryList({
        ...itemCategoryList,
        groupID: parseInt(tokenService.getGroupIDFromToken()),
        factoryID: parseInt(tokenService.getFactoryIDFromToken())
      })
    }
    else {
      setItemCategoryList({
        ...itemCategoryList,
        groupID: IDdata.groupID,
        factoryID: IDdata.factoryID
      })
      setPage(IDdata.page);
      setIsIDDataForDefaultLoad(IDdata);
    }
  }

  async function GetItemCategoryDetailsByGroupIDFactoryID() {
    const factoryItem = await services.GetItemCategoryDetailsByGroupIDFactoryID(itemCategoryList.groupID, itemCategoryList.factoryID);
    if (factoryItem.data.length > 0) {
      setFactoryItemData(factoryItem.data);
    }
    else {
      alert.error("No Records to Display");
    }
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getAllFactoriesByGroupID(itemCategoryList.groupID);
    setFactories(factories);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  function handleChange1(e) {
    const target = e.target;
    const value = target.value
    setItemCategoryList({
      ...itemCategoryList,
      [e.target.name]: value
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
            isEdit={true}
            toolTiptitle={"Add Item Category"}
          />
        </Grid>
      </Grid>
    )
  }

  return (
    <Page
      className={classes.root}
      title="Item Category"
    >
      <Container maxWidth={false}>
        <Formik
          initialValues={{
            groupID: itemCategoryList.groupID,
            factoryID: itemCategoryList.factoryID
          }}
          validationSchema={
            Yup.object().shape({
              groupID: Yup.number().required('Group required').min("1", 'Group required'),
              factoryID: Yup.number().required('Factory required').min("1", 'Factory required'),
            })
          }
          enableReinitialize
        >
          {({
            errors,
            handleBlur,
            handleSubmit,
            handleChange,
            isSubmitting,
            touched,
            values,
            props
          }) => (
            <form onSubmit={handleSubmit}>
              <Box mt={0}>
                <Card>
                  <CardHeader
                    title={cardTitle("Item Category")}
                  />
                  <PerfectScrollbar>
                    <Divider />
                    <CardContent style={{ marginBottom: "2rem" }}>
                      <Grid container spacing={3}>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group  *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.groupID && errors.groupID)}
                            fullWidth
                            helperText={touched.groupID && errors.groupID}
                            name="groupID"
                            onChange={(e) => handleChange1(e)}
                            value={itemCategoryList.groupID}
                            variant="outlined"
                            size='small'
                            InputProps={{
                              readOnly: !permissionList.isGroupFilterEnabled,
                            }}
                          >
                            <MenuItem value={0}>--Select Group--</MenuItem>
                            {generateDropDownMenu(groups)}
                          </TextField>
                        </Grid>

                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="factoryID">
                            Factory  *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.factoryID && errors.factoryID)}
                            fullWidth
                            helperText={touched.factoryID && errors.factoryID}
                            name="factoryID"
                            onChange={(e) => handleChange1(e)}
                            value={itemCategoryList.factoryID}
                            variant="outlined"
                            size='small'
                            InputProps={{
                              readOnly: !permissionList.isFactoryFilterEnabled,
                            }}
                          >
                            <MenuItem value={0}>--Select Factory--</MenuItem>
                            {generateDropDownMenu(factories)}
                          </TextField>
                        </Grid>

                        <Grid container justify="flex-end">
                          <Box pr={2}>
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={() => trackPromise(GetItemCategoryDetailsByGroupIDFactoryID())}
                            >
                              Search
                            </Button>
                          </Box>
                        </Grid>

                      </Grid>

                    </CardContent>
                    {factoryItemData.length > 0 ?
                      <Box minWidth={1050}>
                        <MaterialTable
                          title="Multiple Actions Preview"
                          columns={[
                            { title: 'Item Category Code', field: 'categoryCode' },
                            { title: 'Item Category Name', field: 'categoryName' },
                            { title: 'Item Short Code', field: 'shortCode' },
                            { title: 'Description', field: 'categoryDescription', render: rowData => rowData.categoryDescription ? rowData.categoryDescription : '-' },
                            { title: 'Status', field: 'isActive', render: rowData => rowData.isActive == true ? 'Active' : 'Inactive' },
                          ]}
                          data={factoryItemData}
                          options={{
                            exportButton: false,
                            showTitle: false,
                            headerStyle: { textAlign: "left", height: '1%' },
                            cellStyle: { textAlign: "left" },
                            columnResizable: false,
                            actionsColumnIndex: -1,
                            initialPage: page,
                          }}
                          actions={[
                            {
                              icon: 'mode',
                              tooltip: 'Edit Item Category',
                              onClick: (event, rowData) => { handleClickEdit(rowData.itemCategoryID, event) }
                            },
                          ]}
                          onChangePage={page => setPage(page)}
                        />
                      </Box>
                      : null}
                  </PerfectScrollbar>
                </Card>
              </Box>
            </form>
          )}
        </Formik>
      </Container>
    </Page>
  );
};
